import { graphql } from 'parkdepot-shared/gql'

const B2C_GET_ERROR_FLOW_CHECKOUT_SESSION = graphql(`
    query B2CGetErrorFlowCheckoutSession(
        $lot_id: String!
        $plate: String!
        $country: String!
        $start_date: timestamptz!
        $end_date: timestamptz
        $selected_parking_tariff: String
        $parking_context_uuid: String
        $email: String
        $language: String
    ) {
        b2c_errorflow_checkout(
            lot_id: $lot_id
            plate: $plate
            country: $country
            start_date: $start_date
            end_date: $end_date
            selected_parking_tariff: $selected_parking_tariff
            parking_context_uuid: $parking_context_uuid
            email: $email
        ) {
            adyen_id
            adyen_session_data
        }
    }
`)

export default B2C_GET_ERROR_FLOW_CHECKOUT_SESSION
